import React, { useContext, useCallback, memo } from 'react';

import {
  REASON_INCORRECT_INFORMATION,
  REASON_INSTRUCTION_IGNORED,
  REASON_IRRELEVANT_RESPONSE,
  REASON_OTHER,
  REASONS,
} from './constants';
import {
  Grid,
  makeStyles,
  ToggleButton,
  CheckBoxIcon,
  Typography,
  CheckBoxOutlineBlankIcon,
} from '@gogame/components';
import { FormContext, FormField } from '@gogame/form';

const useStyles = makeStyles(() => ({
  toggleButton: {
    justifyContent: 'flex-start',
    padding: '16px',
  },
  label: {
    marginLeft: '8px',
    textTransform: 'none',
  },
}));

const ButtonGroupItem = memo(({ checked, value, label }) => {
  const classes = useStyles();
  return (
    <Grid item sx={{ width: '50%' }}>
      <ToggleButton value={value} className={classes.toggleButton}>
        {checked ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />}
        <Typography
          variant={'body1'}
          color={'text.primary'}
          className={classes.label}
        >
          {label}
        </Typography>
      </ToggleButton>
    </Grid>
  );
});

const REASONS_LIST = [
  {
    value: REASON_INCORRECT_INFORMATION,
    label: 'Incorrect information',
  },
  {
    value: REASON_INSTRUCTION_IGNORED,
    label: 'Instructions ignored',
  },
  {
    value: REASON_IRRELEVANT_RESPONSE,
    label: 'Irrelevant response',
  },
  {
    value: REASON_OTHER,
    label: 'Other',
  },
];

export default () => {
  const { values } = useContext(FormContext);
  const isChecked = useCallback(
    (value) => values[REASONS]?.includes(value) || false,
    [values]
  );
  return (
    <FormField.ToggleButtonGroup
      name={REASONS}
      padding={0}
      exclusive={false}
      fullWidth={true}
    >
      <Grid container spacing={2}>
        {REASONS_LIST.map((reason) => (
          <ButtonGroupItem
            key={reason.value}
            checked={isChecked(reason.value)}
            value={reason.value}
            label={reason.label}
          />
        ))}
      </Grid>
    </FormField.ToggleButtonGroup>
  );
};
